import React, { useState, useEffect } from 'react';
import '../Requests.css';

function SearchFilter({  langLocal, translate }) {
  const [searchTerm, setSearchTerm] = useState('');

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
  };


  return (
    <div className='div_search_filterr' dir={langLocal === 'ar' ? 'rtl' : 'ltr'}>
      <div>
        <i className={`fa fa-filter icon-filter ${langLocal === 'ar' ? 'border_filter_left padding_left_20' : 'border_filter_right padding_right_20'}`}></i>
      </div>
      <div className={`search_filter_input ${langLocal === 'ar' ? 'margin_right_20' : 'margin_left_20'}`}>
        <i className='fa fa-search'></i>
        <input
          type='text'
          placeholder={`${translate('search_filter')} ...`}
          value={searchTerm}
          onChange={handleSearchChange}
        />
      </div>
    </div>
  );
}

export default SearchFilter;